import { render, staticRenderFns } from "./OrganizationSection.vue?vue&type=template&id=f9d9c294&"
import script from "./OrganizationSection.vue?vue&type=script&lang=js&"
export * from "./OrganizationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports